


import ProductCategories from '@/components/products/product-categories/ProductCategories.vue'
import ProductsInCategory
  from '@/components/products/products-list/products-in-category/ProductsInCategory.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    ProductCategories,
    ProductsInCategory
  }
})
export default class ProductsList extends Vue {
  get categoryId() {
    return parseInt(this.$route.params.categoryId)
  }
}
